import { Tooltip, Badge, Box } from '@mui/material';
import colors from '../../../scss/colors';

const NudgeIcon = ({ iconComponent, onClick, nudge = false, tooltipText = '', iconColor = colors.NAVY_BLUE }) => {
  const icon = (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: iconColor
      }}
      onClick={onClick}
    >
      {iconComponent}
    </Box>
  );

  return nudge ? (
    <Tooltip title={tooltipText} arrow>
      <Badge
        color="error"
        variant="dot"
        overlap="circular"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {icon}
      </Badge>
    </Tooltip>
  ) : (
    icon
  );
};

export default NudgeIcon;
